import { createRoot } from "react-dom/client";
import App from "./App";
import { captureAttribution } from "./lib/attribution";
import "./index.css";

// Read campaign parameters before the router can rewrite the URL.
captureAttribution();

createRoot(document.getElementById("root")!).render(<App />);
